module.exports = __webpack_public_path__ + "static/media/Forester_logo.18ca450a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/Forester_logo.svg
// module id = 328
// module chunks = 0